import React from "react";
import waveTop from "../../assets/images/Frame 1916.png"; // your wave background image
import time from "../../assets/icons/DescriptionIcons/time.png";
import scope from "../../assets/icons/DescriptionIcons/scope.png";
import idea from "../../assets/icons/DescriptionIcons/idea.png";
import up from "../../assets/icons/DescriptionIcons/up.png";
import medal from "../../assets/icons/DescriptionIcons/medal.png";
import handShake from "../../assets/icons/DescriptionIcons/handshake.png";

const Description = () => {
  return (
    <section className="relative z-20  text-white text-center">
      {/* Top Wave */}
      <div className="absolute md:-top-[136px] -top-[215px] left-0 w-full overflow-hidden z-50]">
        <img
          src={waveTop}
          alt="Top Wave"
          className="md:w-full max-w-[2500px] md:h-[975px] h-[1750px]"
          style={{ transform: "translateY(-1px)" }}
        />
      </div>

      {/* Content of Purple Section */}
      <div className="relative z-10 max-w-7xl mx-auto pt-20 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-[44px] mb-4">Неге Ustaz Kids?</h2>
        <p className="mb-8 text-2xl">
          Өйткені біз тәрбиешінің жанындағы көмекшіміз.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-x-36">
          {[
            [time, "Уақытты үнемдейтін дайын жоспарлар мен материалдар"],
            [scope, "Артық ізденуді қажет етпейтін жүйеленген контент"],
            [idea, "Техникалық құралсыз-ақ іске асатын шығармашылық идеялар"],
            [up, "Кәсіби даму мен шабыт беретін мастер-класстары"],
            [medal, "Еңбекті бағалайтын марапат пен қолдау жүйесі"],
            [
              handShake,
              "Тәрбиеші мен ата-ана арасындағы тиімді қарым-қатынас құру жолдары",
            ],
          ].map(([icon, text], idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center p-4"
            >
              <div className="bg-[#F3DA6D] md:w-24 md:h-24 w-20 h-20 rounded-full flex items-center justify-center mb-5 shadow-md">
                <img
                  src={icon}
                  alt="icon"
                  className="md:w-14 md:h-14 w-12 h-12  object-contain"
                />
              </div>
              <p className="text-sm md:text-md lg:text-lg font-medium">
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Description;
